import { Outlet } from 'react-router';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav';

import { FixtureTabLayout } from '#src/layouts/FixtureLayout/FixtureTabLayout/index.tsx';

const CareerBoardLayout = () => {
  const enableSorare27Nav = useEnableSorare27Nav();

  if (enableSorare27Nav) {
    return <Outlet />;
  }

  return (
    <FixtureTabLayout
      eventType={So5FixtureEvent.CLASSIC}
      so5FixtureSlug="ongoing"
    >
      <Outlet />
    </FixtureTabLayout>
  );
};

export default CareerBoardLayout;
